import BrowserDetectData from 'gw-portals-featuredetection-js/browserdetect/BrowserDetectData';

/**
 * Report service calls
 * Payload for each call must be customized.
 * @param window
 * @returns {{trackPageView: trackPageView, trackServerCall: trackServerCall, trackServerCallError: trackServerCallError, trackWizard: trackWizard, trackPurchase: trackPurchase}}
 */
export default (function (window, gtm, StateUtils) {
    window.dataLayer = window.dataLayer || [];
    var trackPageView = function trackPageView(event) {
        window.dataLayer.push({
            event: event.eventName,
            category: event.category,
            path: event.payload.path,
            method: event.payload.path,
            action: event.payload.path,
            eventAction: event.payload.path,
            channel: BrowserDetectData.browserType
        });
    };
    var trackServerCall = function trackServerCall(event) {
        window.dataLayer.push({
            event: 'serverCall',
            eventLabel: event.eventName,
            category: 'serverCall',
            path: event.payload.path,
            action: event.payload.path,
            eventAction: event.payload.path,
            method: event.payload.path,
            elapsedTime: event.payload.elapsedTime,
            requestId: event.payload.requestId
        });
    };
    var trackServerCallError = function trackServerCallError(event) {
        window.dataLayer.push({
            eventCategory: 'serviceCallError',
            path: event.payload.path,
            method: event.payload.method,
            elapsedTime: event.payload.elapsedTime,
            errorMessage: event.payload.errorMessage,
            requestId: event.payload.requestId
        });
    };
    var trackWizard = function trackWizard(event) {
        window.dataLayer.push(event);
    };
    var trackPurchase = function trackPurchase(event) {
        window.dataLayer.push(event);
    };
    var fieldTrackCallback = function fieldTrackCallback(event) {

        window.dataLayer.push({
            event: 'fieldTracking',
            category: 'fieldTracking',
            path: event.payload.path,
            fieldName: event.payload.fieldName,
            action: '',
            eventAction: '',
            channel: BrowserDetectData.browserType
        });
    };
    gtm();
    return {
        trackPageView: trackPageView,
        trackServerCall: trackServerCall,
        trackServerCallError: trackServerCallError,
        trackWizard: trackWizard,
        trackPurchase: trackPurchase,
        fieldTrackCallback: fieldTrackCallback
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-js/adapters/GoogleTagManagerAdapter.js
// module id = 920
// module chunks = 0